// extracted by mini-css-extract-plugin
export default {"text":"index-module_text_zNxxD","index":"index-module_index_va9QI","content":"index-module_content_AyIO5","title":"index-module_title_tDZon","subTitle":"index-module_subTitle_xnhoK"};